/**
 * Marks a banner slide as commercial advertising or as Izenu's own communication.
 *
 *   'ad'  — hidden from subscribers.
 *   'app' — shown to everybody, subscribers included.
 *
 * Same visual idiom as AdLinkBadge so the two sit together on a card.
 */
export default function BannerTypeBadge({ type }) {
    const isApp = type === "app";

    const style = {
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontSize: 10,
        padding: "2px 6px",
        borderRadius: 4,
        background: isApp ? "#dcfce7" : "#dbeafe",
        color: isApp ? "#166534" : "#1e40af",
    };

    return (
        <div
            style={style}
            title={
                isApp
                    ? "Padrão da app — visível para todos, incluindo assinantes"
                    : "Publicidade — escondida de quem tem assinatura"
            }
        >
            {isApp ? "📱 Padrão da app" : "📢 Publicidade"}
        </div>
    );
}
